module.exports = __webpack_public_path__ + "static/media/twitter.5732ae1c.svg";